<template>
    <div>
        <div v-if="isMobile && availableLanguages.length > 1" class="select">
            <select v-model="lang">
                <option
                    v-for="l in availableLanguages"
                    :key="l"
                    :value="l"
                >{{langDescriptions[l]}}</option>
            </select>
        </div>
        <div v-if="!isMobile && availableLanguages.length > 1"
            class="dropdown is-up is-hoverable languages"
        >
            <div class="dropdown-trigger">
                <button class="button">
                    <span class="icon">
                        <i class="fas fa-globe" aria-hidden="true"></i>
                    </span>
                    <span>{{langDescriptions[lang]}}</span>
                    <span class="icon is-small">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                <div class="dropdown-content">
                    <a
                        v-for="l in availableLanguages"
                        :key="l"
                        class="dropdown-item"
                        @click="lang=l"
                    >
                        <span>{{langDescriptions[l]}}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'basement-languages',
    data() {
        return {
            isMobile: isMobile.phone || isMobile.tablet,
        };
    },
    computed: {
        lang: {
            get() {
                return Vue.state.lang.currentLang;
            },
            set(val) {
                Vue.state.lang.currentLang = val;
            }
        },
        availableLanguages() {
            return Vue.state.lang.availableLanguages;
        },
        langDescriptions() {
            return Vue.state.lang.langDescriptions;
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/basement/languages.vue